import {
    createHeadline,
    IHeadlineProperties,
} from '@vfde-brix/headline';
import {
    createImageCaptionListComponent,
    IImageCaptionList,
} from '@vfde-brix/image-caption-list';
import {IImageCaptionProperties} from '@vfde-brix/image-caption';

/**
 * creates the Multi-Divider Headline
 * @param elMultiDividerHeadline
 * @param headlineProperties
 */
export const createMultiDividerHeadline = (elMultiDividerHeadline: HTMLElement, headlineProperties: IHeadlineProperties) => {
    createHeadline(elMultiDividerHeadline, headlineProperties);
};

/**
 * creates the Image-Caption-List
 * @param elMultiDividerImageCaptionList
 * @param captionListProperties
 */
export const createMultiDividerCaptionList = (elMultiDividerImageCaptionList: HTMLElement, captionListProperties: IImageCaptionList<IImageCaptionProperties>) => {
    createImageCaptionListComponent(elMultiDividerImageCaptionList, captionListProperties);
};
